<template>
  <div class="hg-order-progress">
    <el-steps :active="activeItem" :align-center="iscenter">
      <el-step v-for="(item, index) in items" :key="index" :title="getStatusLabel(item,index)" @click="onClickStatus(item)" :class="[item.name=='LAB_SAMPLE_RETURNED' ? 'hidden' : 'show',index+1 == activeItem ? 'change-line' :'',
        item.color=='red' ?'abnormal': (item.color=='orange'?'pending':''),item.name==='CLOSED' ? 'closed' :'']">
        <el-button type="text" slot="icon" size="mini" @click="onClickStatus(item.name)" :class="['iconfont',item.icon]"></el-button>
        <!-- <el-button type="text" v-else slot="icon" size="mini" @click="onClickStatus(item.name)">{{index+1}}</el-button> -->
        <div slot="description">
          <div class="operatorName">{{item.operatorName}}</div>
          <!-- <div v-for="(history, index) in item.history" :key="index" :class="{'expired':history.expired}">
            <div v-if="item.history.length > 0">
              <span v-if="index == 1">{{history.time}}</span>
              <span v-else-if="index == 2">{{history.time}}</span>
              <span v-else>{{history.time}}</span>
            </div>
          </div> -->
          <div v-if="item.history.length > 0">
            <div v-for="(history, index) in item.history" :key="index" :class="{'expired':history.expired}">
              <div><span style="white-space: nowrap;">{{history.time}}</span></div>
            </div>
          </div>
        </div>
      </el-step>
    </el-steps>
  </div>
</template>
<script>
/**
   * 订单状态进度条，用于展示订单的整体进度状态 test
   */
import {
  deepClone,
  formatDateObject
} from '@/utils/formUtils'
import orderflowHelper from '@/config/order'
import { formatActionAcceptableResult } from 'enumeration/lab-order'
const RISK_TEST = 'RISK_TEST'
export default {
  name: 'order-progress',
  props: {
    // 订单id
    orderId: [String],
    // 订单的当前状态集合数组
    orderStatus: [Array],
    productOnlyData: [Boolean],
    orderDetail: [Object],
    task: {
      type: Object
    },
    // 是否是任务单
    isTask: [Boolean],
  },
  data () {
    return {
      items: [],
      activeItem: 1,
      iscenter: true,
      creatNum: 0,
      isShowClose: false
    }
  },
  computed: {
    closeStatus () {
      let lastStatus = this.orderStatus[this.orderStatus.length - 1]
      if (this.orderDetail.orderStatusEnum === 'CLOSED') {
        return lastStatus.action
      }
      if (this.isTask && this.orderDetail.status === 'PRODUCTION_TASK_CLOSE') {
        return lastStatus.action
      }
      return ''
    }
  },
  watch: {
    orderStatus (old, val) {
      if (old !== val) {
        this.creatNum = 0
        this.changeIsClose()
        this.fillOrderHistory()
      }
    },
    'orderDetail.orderStatusEnum': {
      handler: function (val) {
        this.isShowClose = val === 'CLOSED'
        
        this.items = this.getStatusesItems(this.isShowClose)
        if (this.items.length === 0) {
          this.items = this.getStatusesItems(this.isShowClose)
          this.activeItem = 1
        }
        // TODO： 接接口时注释掉
        this.fillOrderHistory()
      },
      immediate: true,
    },
    'orderDetail.status': {
      handler: function (val) {
        if(this.isTask){
          this.isShowClose =  val === 'PRODUCTION_TASK_CLOSE'
        
          this.items = this.getStatusesItems(this.isShowClose)
          if (this.items.length === 0) {
            this.items = this.getStatusesItems(this.isShowClose)
            this.activeItem = 1
          }
          // TODO： 接接口时注释掉
          this.fillOrderHistory()
        }
       
      },
      immediate: true,
    },
    items (old, vale) {
      // 每次items数组变化，都应该刷新并重新计算订单历史信息。
      this.fillOrderHistory()
    }
  },
  methods: {
    getStatusLabel (data,index) {
      const title = index >= this.activeItem ? data.operation : data.completeText
      if (data.childStatus) {
        return `${title}（${data.childStatus.reason}）`
      } else if (data.text) {
        return `${title}（${data.text}）`
      } else {
        // console.log(this.orderStatus)
        let label
        this.orderStatus.forEach(item => {
          if (data.name === item.action && item.text) {
            label = item.text
          } else if (data.name === this.closeStatus) {
            label = formatActionAcceptableResult(this.orderDetail.orderCloseReason)
          } else if (data.name === 'LAB_DNA_READY' && item.orderStatusResult && item.orderStatusResult === RISK_TEST) {
            label = formatActionAcceptableResult(item.orderStatusResult)
          } else {
            label = ''
          }
        })

        return title + (label ? '(' + label + ')' : '')
      }
    },
    changeIsClose () {
      if (this.orderStatus.length) {
        if (this.orderStatus[this.orderStatus.length - 1].futureActionTask) {
          if (
            this.orderStatus[this.orderStatus.length - 1].futureActionTask
              .status === 'WAITING_FOR_NEW_ORDER' ||
            this.orderStatus[this.orderStatus.length - 1].orderStatus === 'CLOSED'||
            (this.isTask && this.orderStatus[this.orderStatus.length - 1].productionTaskStatus === 'PRODUCTION_TASK_CLOSE')
          ) {
            this.isShowClose = true
            this.getStatusesItems(this.isShowClose)
          }
        }
      }
    },
    // 创建进度条的所有状态项
    getStatusesItems (flag) {
      // let deliveryType = this.orderDetail.currentSample.deliveryTypes
      // let hasReport = deliveryType.includes('ELECTRONIC') || deliveryType.includes('PAPER')
      let items = deepClone(orderflowHelper.getDefaultOrderFlow(flag,this.isTask))
      // items = !hasReport ? items.filter(e => e.type !== 'report') : items
      // // 如果直接送检（直接送样到实验室，不需要样本回寄状态）
      // if (this.orderDetail.directSendSample) {
      //   items = items.filter(e => e.name !== 'SAMPLE_RETURNED')
      // }
      // console.log('flag==hasReport======', hasReport)
      for (let i = 0; i < items.length; i++) {
        items[i].index = i + 1
        items[i].history = []
        items[i].operatorName = '' // 操作人
      }
      this.items = items
      console.log('items=======', items)
      return items
    },
    // 通过订单的历史状态信息填充整个状态数组
    fillOrderHistory () {
      if (this.items.length === 0) {
        return
      }
      for (let item of this.items) {
        item.history = []
      }
      for (let status of this.orderStatus) {
        let statusLookUp = status.action
        if (status.orderStatus === 'LAB_SAMPLE_RETURNED') {
          this.creatNum = this.creatNum + 1
        }
        // 为适应旧数据，旧数据一般是CREATED，可以慢慢迭代为CREATE
        if (statusLookUp === 'CREATED') {
          statusLookUp = 'CREATE'
        }
        let item = this.getItem(statusLookUp)
        if (item) {
          for (let oldItems of item.history) {
            oldItems.expired = true
          }
          item.history.push({
            time: formatDateObject(status.statusTime, 'shortDatetime')
          })
          // this.activeItem = item.index
          item.operatorName = status.auditInformation
            ? status.auditInformation.operatorName
            : ''
          // 使用当前status对应的状态匹配的进度
          // console.log('statusLookup', statusLookUp)
          let itemByStatus = this.getItem(statusLookUp) // status.orderStatus
          // 记录最后一个发生的状态
          // console.log('itemByStatus.index-----------', itemByStatus)
          if (this.isShowClose) {
            this.activeItem = itemByStatus.index - 1
          } else {
            this.activeItem = itemByStatus.index
          }
        } else {
          console.error('unknown order status: ' + status.action)
        }
      }
      // console.log('nextOrderAction', this.orderDetail.nextOrderAction)
      // 可直接利用订单的nextOrderAction来判断下一操作
      let nextOrderAction = this.orderDetail?.nextOrderAction
      if (nextOrderAction === 'NONE') {
        this.activeItem = this.items.length
      } else {
        let nextActionItem = this.getItem(nextOrderAction)
        if (nextActionItem) {
          this.activeItem = nextActionItem.index - 1
        }
      }
      for (let i = this.items.length - 1; i >= 0; i--) {
        let item = this.items[i]
        // 异常关闭订单时，状态标红
        if (this.closeStatus && this.closeStatus === item.name) {
          item.color = 'red'
        } else {
          item.color = ''
        }
        if (this.task && this.task.orderActionData.action === item.name) {
          let subStatus = this.task.subStatus
          if (subStatus) {
            item.color = subStatus.error ? 'red' : 'orange'
            item.text = subStatus.status
          }
          this.activeItem = i
          // WAITING_FOR_NEW_ORDER订单已经在等待重采
          if (this.task.status === 'WAITING_FOR_NEW_ORDER') {
            item.history.push({
              time: formatDateObject(this.task.auditInformation.auditTime, 'shortDatetime')
            })
            item.operatorName = this.task.auditInformation.auditorName
          }
          break
        } else {
          item.text = ''
        }
      }
      // 填充childStatus
      let latestActiveItem = this.items.find(item => {
        console.log(item.operation, item.history)
        return item.history.length === 0
      })
      // console.log('latestActiveItem', latestActiveItem)
      let lastStatus = this.orderStatus[this.orderStatus.length - 1]
      if (lastStatus && lastStatus.childStatus) {
        latestActiveItem.childStatus = lastStatus.childStatus
      }
      console.log('====items',this.items)
    },
    // 通过状态名查找状态对象
    getItem (name) {
      for (let item of this.items) {
        if (item.name === name) {
          return item
        }
      }
      return null
    },
    onClickStatus (item) {
      this.$emit('statucClick', item)
    }
  },
  created () { 
  }
}

</script>
<style lang="less">
@import "~less/var.less";

.hg-order-progress {
  // 更新element版本后，做的样式修改
  .el-steps {
    display: flex;
    justify-content: center;
  }

  .el-step__head.is-process {
    .el-step__icon {
      background-color: @iconBackgroundColor;
    }
  }

  .el-step__head.is-wait {
    // background-color: #d5d5d5;
    // border-color: #d5d5d5;
    .el-step__icon {
      background-color: #d5d5d5;
    }
  }

  .el-step__icon.is-text {
    border: none;
  }

  .el-step__head.is-horizontal {
    background-color: @mainColor;
    border-color: @mainColor;

    .el-step__icon {
      background-color: @mainColor;
    }
  }

  .el-step__icon,
  .closed .el-step__head.is-wait .el-step__icon {
    background-color: @iconCompletedColor;
    width: 40px;
    height: 40px;
  }
  .el-step__title {
    line-height: 1.2 !important;
    margin: 10px 0;
  }
  .closed .el-step__title {
    color: @iconCompletedColor;
  }

  .el-step__head {
    position: static;
  }

  .el-step.is-horizontal .el-step__line {
    top: 22px;
    height: 2px;
    // left: 40px;
    // right: 0;
  }

  .expired {
    line-height: 20px;
    // color: #BBBBBB
  }

  button {
    background: none;
    border: none;
    color: white;
    min-width: 20px;

    span {
      color: white !important;
    }

    &:hover {
      color: white;
    }

    &:active {
      color: white;
    }
  }

  .hidden {
    display: none;
  }

  .only-data {
    display: none;
  }

  .el-step__head.is-finish {
    border-color: @iconCompletedColor;
  }

  .el-step__title.is-finish,
  .el-step__description.is-finish {
    color: @iconCompletedColor;
  }

  .change-line {
    > .el-step__head.is-finish {
      > .el-step__line .el-step__line-inner {
        transition-delay: 300ms !important;
        border-width: 1px !important;
        width: 50% !important;
      }
    }
  }

  .el-step__description {
    line-height: 0.1rem;
  }

  .el-button--mini {
    font-size: 22px;
  }

  .pending {
    .el-step__head .el-step__icon {
      background-color: #f69b07;
      border-color: #f69b07;
    }

    .el-step__title {
      color: #f69b07;
    }

    .el-step__description.is-process {
      color: #f69b07;
    }
  }

  .abnormal {
    .el-step__head.is-process .el-step__icon,
    .el-step__head .el-step__icon {
      background-color: #f56c6c;
      border-color: #f56c6c;
    }

    .el-step__title.is-process,
    .el-step__title {
      color: #f56c6c;
    }

    .el-step__description.is-process {
      color: #f56c6c;
    }
  }

  p {
    line-height: 15px;
  }

  span {
    line-height: 15px;
  }
  .operatorName {
    margin: 5px 0;
  }
}
</style>
